import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  SupplementaryBillsList: { loading: false, data: null, error: null },
  SupplementaryBillsCreate: { loading: false, data: null, error: null },
  SupplementaryBillsUpdate: { loading: false, data: null, error: null },
  SupplementaryBillsDelete: { loading: false, data: null, error: null },
  SupplementaryBillsReportUpdateStatus: { loading: false, data: null, error: null },
  SupplementaryBillsById: { loading: false, data: null, error: null },
};

export const SupplementaryBillsSlice = createSlice({
  name: "supplementarybills",
  initialState,
  reducers: {
    fetchSupplementaryBillsListRequest: (state, action) => {
      state.SupplementaryBillsList.loading = true;
      state.SupplementaryBillsList.error = null;
    },
    fetchSupplementaryBillsListSuccess: (state, action) => {
      state.SupplementaryBillsList.data = action.payload;
      state.SupplementaryBillsList.loading = false;
      state.SupplementaryBillsList.error = null;
    },
    fetchSupplementaryBillsListFailure: (state, action) => {
      state.SupplementaryBillsList.data = null;
      state.SupplementaryBillsList.loading = false;
      state.SupplementaryBillsList.error = action.payload;
    },
    SupplementaryBillsCreateRequest: (state, action) => {
      state.SupplementaryBillsCreate.loading = true;
      state.SupplementaryBillsCreate.error = null;
    },
    SupplementaryBillsCreateSuccess: (state, action) => {
      state.SupplementaryBillsCreate.data = action.payload;
      state.SupplementaryBillsCreate.loading = false;
      state.SupplementaryBillsCreate.error = null;
      state.SupplementaryBillsList = addNewSupplementaryBillsSuccess(
        action.payload,
        {
          ...state.SupplementaryBillsList,
        }
      );
    },
    SupplementaryBillsCreateFailure: (state, action) => {
      state.SupplementaryBillsCreate.data = null;
      state.SupplementaryBillsCreate.loading = false;
      state.SupplementaryBillsCreate.error = action.payload;
    },
    resetSupplementaryBillsStatus: (state, action) => {
      state.SupplementaryBillsCreate.data = null;
      state.SupplementaryBillsCreate.loading = false;
      state.SupplementaryBillsCreate.error = null;
      state.SupplementaryBillsUpdate.data = null;
      state.SupplementaryBillsUpdate.loading = false;
      state.SupplementaryBillsUpdate.error = null;
    },
    SupplementaryBillsUpdateRequest: (state, action) => {
      state.SupplementaryBillsUpdate.loading = true;
      state.SupplementaryBillsUpdate.error = null;
    },
    SupplementaryBillsUpdateSuccess: (state, action) => {
      state.SupplementaryBillsUpdate.data = action.payload;
      state.SupplementaryBillsUpdate.loading = false;
      state.SupplementaryBillsUpdate.error = null;
      state.SupplementaryBillsList = updateSupplementaryBillsSuccess(
        action.payload,
        {
          ...state.SupplementaryBillsList,
        }
      );
    },
    SupplementaryBillsUpdateFaliure: (state, action) => {
      state.SupplementaryBillsUpdate.data = null;
      state.SupplementaryBillsUpdate.loading = false;
      state.SupplementaryBillsUpdate.error = action.payload;
    },
    SupplementaryBillsDeleteRequest: (state, action) => {
      state.SupplementaryBillsDelete.loading = true;
      state.SupplementaryBillsDelete.error = null;
    },
    SupplementaryBillsDeleteSuccess: (state, action) => {
      state.SupplementaryBillsDelete.data = action.payload;
      state.SupplementaryBillsDelete.loading = false;
      state.SupplementaryBillsDelete.error = null;
      state.SupplementaryBillsList = deleteSupplementaryBills(action.payload, {
        ...state.SupplementaryBillsList,
      });
    },
    SupplementaryBillsDeleteFaliure: (state, action) => {
      state.SupplementaryBillsDelete.data = null;
      state.SupplementaryBillsDelete.loading = false;
      state.SupplementaryBillsDelete.error = action.payload;
    },
    //update billStatus
    supplementaryBillsReportUpdateStatusRequest: (state, action) => {
      state.SupplementaryBillsReportUpdateStatus.loading = true;
      state.SupplementaryBillsReportUpdateStatus.error = null;
    },
    supplementaryBillsReportUpdateStatusSuccess: (state, action) => {
      state.SupplementaryBillsReportUpdateStatus.data = action.payload;
      state.SupplementaryBillsReportUpdateStatus.loading = false;
      state.SupplementaryBillsReportUpdateStatus.error = null;

      state.SupplementaryBillsList = updateSupplementaryBillsReportStatusSuccess(
        action.payload,
        state.SupplementaryBillsList
      );
    },
    supplementaryBillsReportUpdateStatusFailure: (state, action) => {
      state.SupplementaryBillsReportUpdateStatus.data = null;
      state.SupplementaryBillsReportUpdateStatus.loading = false;
      state.SupplementaryBillsReportUpdateStatus.error = action.payload;
    },
    fetchSupplementaryBillsByIdRequest: (state, action) => {
      state.SupplementaryBillsById.loading = true;
      state.SupplementaryBillsById.error = null;
    },
    fetchSupplementaryBillsByIdSuccess: (state, action) => {
      state.SupplementaryBillsById.data = action.payload;
      state.SupplementaryBillsById.loading = false;
      state.SupplementaryBillsById.error = null;
    },
    fetchSupplementaryBillsByIdFailure: (state, action) => {
      state.SupplementaryBillsById.data = null;
      state.SupplementaryBillsById.loading = false;
      state.SupplementaryBillsById.error = action.payload;
    },

  },
});

function addNewSupplementaryBillsSuccess(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}

function updateSupplementaryBillsSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((target) => {
    if (target._id !== dataToUpdate._id) return target;
    return { ...target, ...dataToUpdate };
  });
  return state;
}

function deleteSupplementaryBills(dataToRemove, state) {
  state.data.data = state.data.data.filter((e) => e._id !== dataToRemove.data);
  return state;
}

// updateSupplementaryBillsReportStatusSuccess
function updateSupplementaryBillsReportStatusSuccess(dataToUpdate, state) {
  state.data.data = [...dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}

export const {
  fetchSupplementaryBillsListRequest,
  fetchSupplementaryBillsListSuccess,
  fetchSupplementaryBillsListFailure,
  SupplementaryBillsCreateRequest,
  SupplementaryBillsCreateSuccess,
  SupplementaryBillsCreateFailure,
  SupplementaryBillsUpdateRequest,
  SupplementaryBillsUpdateSuccess,
  SupplementaryBillsUpdateFaliure,
  SupplementaryBillsDeleteRequest,
  SupplementaryBillsDeleteSuccess,
  SupplementaryBillsDeleteFaliure,
  resetSupplementaryBillsStatus,
  supplementaryBillsReportUpdateStatusRequest,
  supplementaryBillsReportUpdateStatusSuccess,
  supplementaryBillsReportUpdateStatusFailure,
  fetchSupplementaryBillsByIdRequest,
  fetchSupplementaryBillsByIdSuccess,
  fetchSupplementaryBillsByIdFailure
} = SupplementaryBillsSlice.actions;

export const getSupplementaryBillsSliceListState = (store) =>
  store.supplementarybills?.SupplementaryBillsList;
export const getSupplementaryBillsSliceCreateState = (store) =>
  store.supplementarybills?.SupplementaryBillsCreate;
export const getSupplementaryBillsSliceUpdateState = (state) =>
  state.supplementarybills?.SupplementaryBillsUpdate;
  export const getSupplementaryBillsByIdSliceListState = (store) =>
  store.supplementarybills?.SupplementaryBillsById;
export default SupplementaryBillsSlice.reducer;
